// supported-currencies
// https://support.google.com/analytics/answer/6205902#supported-currencies&zippy=%2Cin-this-article

/*
GTM - TEST SCRIPT

APP
00--- Onboarding
00--- Refferal id on login
01--- Page visit (every page)

02--- Registration & Login
    signup - is_new /registration page
    login

03--- Subscription tiers
    entered from subpage
    track if user left via back btn
    tier selection
    payment selection
    payment gate
    thx page
        -how did you find us popup
        -discord link

04---Upgrade popup / Upgrade flow z subscription
    close dialog
    pick option
    step 1
    step 2
    step thx

06---Subscription cancel popup
07---Subscription renewal btn

08---Registration via refferal

09---Others
    discord link - only first time
    socials click - homepage

HOMEPAGE
    Social links
    Page visit (every page)

 */

// function gtm_track_pagetype(page) {
//     const p = {
//         event: 'page_category_identification',
//         'page.category.pageType': page, // nazev stranky
//         user: {
//             registered: 'no',
//         },
//     }
//     window.dataLayer = window.dataLayer || []
//     window.dataLayer.push(p)
// }

function gtm_push({ fn, p }) {
  // console.log(fn, JSON.parse(JSON.stringify(p)))
  if (import.meta.env.VITE_ENV === 'production') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(p)
  }
}

function getPaymentType(paymentType) {
  // annually  monthly
  const res = paymentType === 'yearly' ? 'annually' : paymentType
  return res
}

// referrer url

// Pagetype & User info -------------------------------------------------------------

// each fresh pageview
function gtm_page_category_identification({ path_name, id, locale, registered, activatedGames }) {
  const p = {
    event: 'page_category_identification',
    'page.category.pageType': path_name,
    // !!! never send email as its against GA-GOOGLE policy
    user: {
      id, // ID user
      language: locale,
      registered, // status registered/not-registered
    },
    activatedGames,
  }
  gtm_push({ fn: 'gtm_page_category_identification', p })
}

// Registration & Login ---------------------------------------------------------------
// https://app.gtowizard.com/login

// Registrácia zákazníckeho účtu (po stlačení “Login”)
function gtm_login_accountSignUp() {
  const p = {
    event: 'accountSignUp',
  }
  gtm_push({ fn: 'gtm_login_accountSignUp', p })
}

// Prihlásenie zákazníckeho účtu (po stlačení “Login”)
function gtm_login_accountLogIn() {
  const p = {
    event: 'accountLogIn',
  }
  gtm_push({ fn: 'gtm_login_accountLogIn', p })
}

// onboarding na step2
function gtm_onboarding({ game, mode }) {
  const p = {
    event: 'onboarding',
    game,
    mode,
  }
  gtm_push({ fn: 'gtm_onboarding', p })
}

// Pick & Order Subscription -----------------------------------------------------------
// https://app.gtowizard.com/subscription/tier-overview

// Zobrazenie Subscriptions tiers
// z ktorého prišiel užívateľ na podstránku tierov - (coaching, practise, analyze, study)
function gtm_sub_subpage_action({ from_path_name, action, game, type }) {
  const p = {
    event: 'showSubscriptions',
    source: from_path_name,
    ...(action
      ? {
          actionField: {
            action,
            ...(game ? { game } : {}),
            ...(type ? { type } : {}),
          },
        }
      : {}),
  }
  gtm_push({ fn: 'gtm_sub_subpage_action', p })
}

// Výber Subscription tieru (po kliku na “get started”)
function gtm_sub_selection({ currencyCode = 'USD', from_path_name, game, type }) {
  const p = {
    event: 'chooseSubscription',
    currencyCode,
    source: from_path_name,
    membership: {
      game, // Typ vybranej hry
      type, // Typ subscription modelu
    },
  }
  gtm_push({ fn: 'gtm_sub_selection', p })
}

// Purchase Subscription - Checkout - Step 1
// https://app.gtowizard.com/subscription/payment-selection
function gtm_sub_purchase_01({ currencyCode = 'USD', game, type, paymentType, price }) {
  const p = {
    event: 'checkout',
    currencyCode,
    purchaseSubscription: {
      checkout: {
        actionField: { step: 1 },
        subscription: [
          {
            game, // Typ vybranej hry
            type, // Typ subscription modelu
            paymentType: getPaymentType(paymentType), // Periodicita platby
            price, // Bez meny, s bodkou
          },
        ],
      },
    },
  }
  gtm_push({ fn: 'gtm_sub_purchase_01', p })
}

// Purchase Subscription - Checkout - Step 2
// https://app.gtowizard.com/subscription/payment-gate
function gtm_sub_purchase_02({
  currencyCode = 'USD',
  payment_provider,
  game,
  type,
  paymentType,
  price,
}) {
  const p = {
    event: 'checkout',
    currencyCode,
    purchaseSubscription: {
      checkout: {
        actionField: {
          step: 2,
          option: payment_provider, // 'payment:paypal',
        },
        subscription: [
          {
            game, // Typ vybranej hry
            type, // Typ subscription modelu
            paymentType: getPaymentType(paymentType), // Periodicita platby
            price, // Bez meny, s bodkou
          },
        ],
      },
    },
  }
  gtm_push({ fn: 'gtm_sub_purchase_02', p })
}

// Thank you page
function gtm_sub_thxpage({
  currencyCode = 'USD',
  transaction_id,
  transaction_revenue,
  game,
  type,
  paymentType,
  price,
}) {
  const p = {
    event: 'purchaseSubscription',
    currencyCode,
    purchaseSubscription: {
      purchase: {
        actionField: {
          id: transaction_id,
          revenue: transaction_revenue, // '69.00' hodnota transakcie bez dane
          subscription: [
            {
              game, // Typ vybranej hry
              type, // Typ subscription modelu
              paymentType: getPaymentType(paymentType), // Periodicita platby
              price, // Bez meny, s bodkou
            },
          ],
        },
      },
    },
  }
  gtm_push({ fn: 'gtm_sub_thxpage', p })
}
// How did you find us (pop up)
function gtm_sub_findUsDialog({ source }) {
  const p = {
    event: 'showPopup',
    type: 'howDidYouFindUs',
    externalSource: source, // twitter, facebook, instagram, youtube, discord, 2+2
  }
  gtm_push({ fn: 'gtm_sub_findUsDialog', p })
}
// Discord tag
// odoslanie discord tagu >> predpoklad pripojenia člena na DC server
function gtm_sub_discord() {
  const p = {
    event: 'discordTag',
  }
  gtm_push({ fn: 'gtm_sub_discord', p })
}

// Upgrade subscription----------------------------------------------
function gtm_sub_upgrade_dialog({ subpage }) {
  const p = {
    event: 'showPopup',
    type: 'upgradeSubscription',
    source: subpage, // podľa subpage na ktorej sa mu Pop-up zobrazil
  }
  gtm_push({ fn: 'gtm_sub_upgrade_dialog', p })
}

function gtm_sub_upgrade_dialog_events({ subpage, action, type, paymentType }) {
  const p = {
    event: 'showPopup',
    type: 'upgradeSubscription',
    source: subpage, // podľa subpage na ktorej sa mu Pop-up zobrazil
    actionField: {
      action, // pick close
      ...(type ? { type } : {}),
      ...(paymentType ? { paymentType: getPaymentType(paymentType) } : {}),
    },
  }
  gtm_push({ fn: 'gtm_sub_upgrade_dialog', p })
}

function gtm_sub_upgrade({ step, currencyCode = 'USD', game, type, paymentType, price }) {
  const p = {
    event: 'upgradeSubscription',
    currencyCode,
    upgradeSubscription: {
      checkout: {
        actionField: { step },
        subscription: [
          {
            game, // Typ vybranej hry
            type, // Typ subscription modelu
            paymentType: getPaymentType(paymentType), // Periodicita platby
            price, // Bez meny, s bodkou
          },
        ],
      },
    },
  }
  gtm_push({ fn: 'gtm_sub_upgrade', p })
}

function gtm_sub_upgrade_thx({
  currencyCode = 'USD',
  transaction_id,
  transaction_revenue,
  game,
  type,
  paymentType,
  price,
}) {
  const p = {
    event: 'purchaseUpgrade',
    currencyCode,
    upgradeSubscription: {
      purchase: {
        actionField: {
          id: transaction_id, // transaction id
          revenue: transaction_revenue, // hodnota transakcie bez dane
          subscription: [
            {
              game, // Typ vybranej hry
              type, // Typ subscription modelu
              paymentType: getPaymentType(paymentType), // Periodicita platby
              price, // Bez meny, s bodkou
            },
          ],
        },
      },
    },
  }
  gtm_push({ fn: 'gtm_sub_upgrade_thx', p })
}

// Cancel subscription----------------------------------------------
function gtm_sub_cancel({ currencyCode = 'USD', game, type }) {
  const p = {
    event: 'cancelSubscription',
    currencyCode,
    subscription: {
      game, // Typ vybranej hry
      type, // Typ subscription modelu
    },
  }
  gtm_push({ fn: 'gtm_sub_cancel', p })
}

// Renewal subscription----------------------------------------------
function gtm_sub_renewal({ currencyCode = 'USD', game, type, paymentType, price }) {
  const p = {
    event: 'renewSubscription',
    currencyCode, // odošle sa kód meny danej krajiny
    renewSubscription: {
      renew: {
        subscription: [
          {
            game, // Typ vybranej hry
            type, // Typ subscription modelu
            paymentType: getPaymentType(paymentType), // Periodicita platby
            price, // Bez meny, s bodkou
          },
        ],
      },
    },
  }
  gtm_push({ fn: 'gtm_sub_cancel', p })
}

// HOMEPAGE -------------------
// Kliknutie linky sociálnych sietí:
function gtm_socials_click({ type }) {
  const p = {
    event: 'socialMedia',
    type, // twitter, facebook, instagram, youtube, discord, 2+2
  }
  gtm_push({ fn: 'gtm_socials_click', p })
}

// Pozvánkový link v Refferals:
// Po tom, ako sa niekto prihlási cez “refferal link”
function gtm_refferal_link() {
  const p = {
    event: 'linkRefferals',
  }
  gtm_push({ fn: 'gtm_refferal_link', p })
}

export {
  gtm_page_category_identification,
  gtm_login_accountSignUp,
  gtm_login_accountLogIn,
  gtm_sub_subpage_action,
  gtm_sub_selection,
  gtm_sub_purchase_01,
  gtm_sub_purchase_02,
  gtm_sub_thxpage,
  gtm_sub_findUsDialog,
  gtm_sub_discord,
  gtm_sub_cancel,
  gtm_sub_renewal,
  gtm_sub_upgrade_dialog,
  gtm_sub_upgrade_dialog_events,
  gtm_sub_upgrade,
  gtm_sub_upgrade_thx,
  gtm_socials_click,
  gtm_refferal_link,
  gtm_onboarding,
}
